'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.accordions = exports.accordion = exports.mobileDetect = exports.tabs = undefined;

var _svg4everybody = require('svg4everybody');

var _svg4everybody2 = _interopRequireDefault(_svg4everybody);

var _mobileDetectInstance = require('./mobile-detect-instance');

var _mobileDetectInstance2 = _interopRequireDefault(_mobileDetectInstance);

var _tabs = require('./tabs');

var _tabs2 = _interopRequireDefault(_tabs);

var _accordion = require('./accordion');

var _accordion2 = _interopRequireDefault(_accordion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = function init() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        svg = _ref.svg;

    (0, _svg4everybody2.default)(svg);
};

exports.tabs = _tabs2.default;
exports.mobileDetect = _mobileDetectInstance2.default;
exports.accordion = _accordion2.default;
exports.accordions = _accordion.accordions;
exports.default = init;


//////////////////
// WEBPACK FOOTER
// ./~/rp-gui-guide/lib/js/index.js
// module id = 263
// module chunks = 0